import React from "react";
import { CircleCheckBigIcon, GlobeIcon, LockIcon } from "lucide-react";
import { images, offerPerks, valueStack } from "../data/offer";
import { CTAButton } from "./CTAButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
export function OfferSection() {
  return <section id="offer" className="bg-navy-900 px-4 py-16 md:py-24" data-id="element-209" data-mp="def114vttjwt">
      <div className="mx-auto max-w-2xl" data-id="element-210" data-mp="idi44js8xg25">
        <h2 className="text-center font-serif text-[30px] font-extrabold leading-tight text-white md:text-5xl" data-id="element-211" data-mp="icghdi1vb54l">
          Here's everything you'll <em className="text-brand-cyan" data-id="element-212" data-mp="mgo6vhg5gp3v">receive today</em>
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white shadow-2xl" data-id="element-213" data-mp="refxm852656h">
          <img src={images.product} alt="Everything included in the Ortho Case Command Center™" className="w-full bg-canvas" loading="lazy" data-id="element-214" data-mp="wby6jyj2skeh" />

          <div className="p-5 md:p-8" data-id="element-215" data-mp="2t7m96chn2xaj">
            <ul className="divide-y divide-navy-900/10" data-id="element-216" data-mp="2y3kt9nvxpt55">
              {valueStack.map(item => <li key={item.title} className="flex items-start justify-between gap-4 py-4 first:pt-0" data-id="element-217" data-mp="12ns0v29366w0">
                  <div data-id="element-218" data-mp="xvquty2ihcef">
                    <p className="text-[17px] font-extrabold text-ink" data-id="element-219" data-mp="xv8na5aefbr7">{item.title}</p>
                    <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-220" data-mp="syic9wdgb6cn">{item.detail}</p>
                  </div>
                  <span className="shrink-0 text-lg font-bold text-muted line-through" data-id="element-221" data-mp="oxyf4ssvo2qi">{item.value}</span>
                </li>)}
            </ul>

            <div className="mt-2 flex items-center justify-between rounded-2xl bg-canvas px-4 py-3" data-id="element-222" data-mp="1gn1i8591371k">
              <span className="font-bold uppercase tracking-wide text-ink" data-id="element-223" data-mp="1ckwrbe9ysoim">Total value</span>
              <span className="text-xl font-black text-alert line-through" data-id="element-224" data-mp="17negficdzz7z">$244 USD</span>
            </div>

            <div className="mt-6 text-center" data-id="element-225" data-mp="16swy6zgsyd1">
              <p className="text-[17px] text-muted" data-id="element-226" data-mp="14gb3iql63up">But you don't have to pay $244.</p>
              <p className="text-[17px] text-muted" data-id="element-227" data-mp="3sbizy3iyby1r">You don't even have to pay $97.</p>
              <p className="mt-4 text-sm font-extrabold uppercase tracking-wider text-navy-800" data-id="element-228" data-mp="3tuixkq6i9alc">Today you can get everything for:</p>
              <p className="mt-1 font-serif text-[88px] font-black leading-none text-cta md:text-[112px]" data-id="element-229" data-mp="2lc39j0le9bw">
                $27
              </p>
              <p className="mt-1 text-base font-bold text-ink" data-id="element-230" data-mp="3otvbmix4vjxz">USD · One-time payment</p>
            </div>

            <ul className="mt-6 grid grid-cols-2 gap-3" data-id="element-231" data-mp="3b2q6j1azxzg9">
              {offerPerks.map(perk => <li key={perk.title} className="rounded-2xl bg-canvas p-3.5" data-id="element-232" data-mp="3fv02oz2pfvqz">
                  <CircleCheckBigIcon className="h-5 w-5 text-cta" aria-hidden="true" data-id="element-233" data-mp="3163n8gybjggc" />
                  <p className="mt-2 text-[15px] font-bold leading-snug text-ink" data-id="element-234" data-mp="363vqu88bsr0d">{perk.title}</p>
                  <p className="mt-0.5 text-[13px] leading-snug text-muted" data-id="element-235" data-mp="2s4451lbki6bt">{perk.text}</p>
                </li>)}
            </ul>

            <div className="mt-6" data-id="element-236" data-mp="2x377cy05xyg3">
              <ScarcityBar data-id="element-237" data-mp="2dhxcpb5inrs4" />
            </div>

            <div className="mt-6" data-id="element-238" data-mp="2diq9bjarh0wj">
              <CTAButton label="Yes, I want the Ortho Case Command Center™" data-id="element-239" data-mp="2djry0qkp9lwq" />
              <p className="mt-3 flex items-center justify-center gap-1.5 text-center text-sm text-muted" data-id="element-240" data-mp="28kf3djnl7ajl">
                <LockIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-241" data-mp="2mjy4hshzdlme" />
                $27 USD · Secure checkout · Lifetime access · 7-Day Guarantee
              </p>
            </div>

            <div className="mt-6 flex items-start gap-3 rounded-2xl bg-brand-light p-4" data-id="element-242" data-mp="2wf86whcajv0p">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-243" data-mp="2rgwwo5i33ihy" />
              <p className="text-sm leading-relaxed text-navy-800" data-id="element-244" data-mp="365b1glz29h15">
                <strong data-id="element-245" data-mp="316zrmb8rn6ix">Automatic currency conversion:</strong> the price is automatically converted to your local currency according to your country.
              </p>
            </div>

            <div className="mt-8" data-id="element-246" data-mp="3a87lmh491l77">
              <Countdown label="The special launch offer ends in:" data-id="element-247" data-mp="3a98zetcnglsm" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}